import { render } from "./AddComplaint.vue?vue&type=template&id=09dea953"
import script from "./AddComplaint.vue?vue&type=script&lang=js"
export * from "./AddComplaint.vue?vue&type=script&lang=js"

import "./AddComplaint.vue?vue&type=style&index=0&id=09dea953&lang=css"

import exportComponent from "D:\\CAS Project\\ESM Web App\\master ESM-WEB\\esm-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__